import { Box, Flex, Text } from "@chakra-ui/react"
import React from "react"
import { format, parseISO } from "date-fns"
import { ptBR } from "date-fns/locale"

export function Card({ production, arrayGravacoes, periodo, totalGravacoes, ultimaData }) {
  function verifyValue(value) {
    if (value === 0 || value === null || value === "0" || value === undefined) {
      return 0
    } else {
      return value
    }
  }

  return (
    <Box
      maxW={"319"}
      w={"100%"}
      boxShadow={"0px 3px 6px #00000029"}
      bgColor={"#fff"}
      minH={"480px"}
      paddingInline={"14px"}
      paddingTop={"13px"}
      display={"flex"}
      flexDir={"column"}
      alignItems={"center"}
      justifyContent={"flex-start"}
    >
      <Text
        as={"h1"}
        textAlign={"center"}
        paddingBlock={"5px"}
        display={"block"}
        width={"100%"}
        color={"#fff"}
        bgColor={production ? "#446173" : "#378BBF"}
        textTransform={"uppercase"}
        fontWeight={"600"}
      >
        Período
      </Text>

      {!production && (
        <Text
          as={"h1"}
          paddingBlock={"5px"}
          color={"#000"}
          bgColor={"#F5F5F5"}
          marginTop={"5px"}
          textAlign={"center"}
          display={"block"}
          width={"100%"}
        >
          {periodo ? periodo : "Nenhum período selecionado"}
        </Text>
      )}
      {production && (
        <Text
          as={"h1"}
          paddingBlock={"5px"}
          color={"#000"}
          bgColor={"#F5F5F5"}
          marginTop={"5px"}
          textAlign={"center"}
          display={"block"}
          width={"100%"}
        >
          {ultimaData
            ? "até " + format(parseISO(ultimaData.PREVISAO_SAIDA), "dd 'de' MMMM", { locale: ptBR })
            : "Nenhum período selecionado"}
        </Text>
      )}
      <Flex w={"100%"} flexDir={"column"} mt={"5px"}>
        <Flex
          w={"100%"}
          bgColor={production ? "#446173" : "#378BBF"}
          paddingBlock={"13px"}
          alignItems={"center"}
          justifyContent={"space-between"}
          paddingInline={"23px"}
          color={"#fff"}
        >
          <Text as={"span"}>
            quant. de
            <Text as={"span"} color={"#FFF700"}>
              {" "}
              ITENS
            </Text>
          </Text>
          <Text as={"span"}>
            quant. de
            <Text as={"span"} color={"#FFF700"}>
              {" "}
              PEÇAS
            </Text>
          </Text>
        </Flex>
        <Flex w={"100%"} gap={2} mt={"4px"}>
          <Flex
            w={"100%"}
            paddingBlock={"5px"}
            alignItems={"center"}
            justifyContent={"space-between"}
            flexDir={"column"}
          >
            {arrayGravacoes?.map((item, index) => (
              <Text
                paddingBlock={"4px"}
                bgColor={index % 2 === 0 ? "#F5F5F5" : "#FFFFFF"}
                display={"block"}
                width={"100%"}
                textAlign={"center"}
              >
                {verifyValue(item.quantidadeGravacao)}
              </Text>
            ))}
          </Flex>
          <Flex
            w={"100%"}
            paddingBlock={"5px"}
            alignItems={"center"}
            justifyContent={"space-between"}
            flexDir={"column"}
          >
            {arrayGravacoes?.map((item, index) => (
              <Text
                paddingBlock={"4px"}
                bgColor={index % 2 === 0 ? "#F5F5F5" : "#FFFFFF"}
                display={"block"}
                width={"100%"}
                textAlign={"center"}
              >
                {verifyValue(item.quantidade)}
              </Text>
            ))}
          </Flex>
        </Flex>
        <Flex
          w={"100%"}
          paddingBlock={"5px"}
          alignItems={"center"}
          justifyContent={"space-between"}
          gap={2}
          color={"#fff"}
        >
          <Text paddingBlock={"4px"} bg={"#378BBF"} display={"block"} width={"100%"} textAlign={"center"}>
            {isNaN(totalGravacoes.quantidadeGravacao) ? 0 : totalGravacoes.quantidadeGravacao}
          </Text>
          <Text paddingBlock={"4px"} bg={"#378BBF"} display={"block"} width={"100%"} textAlign={"center"}>
            {totalGravacoes.quantidade}
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}
